import materialUI from "material-UI";
import styled from "styled-components";
import color from "../../constants/color";

export const Container = styled.div``;

export const LocalizationProvider = styled(materialUI.LocalizationProvider)`
  display: flex;
  align-items: center;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const ContentDate = styled.div`
  width: 50%;

  &:first-of-type {
    margin-right: 8px;
  }
`;

export const DesktopDatePicker = styled(materialUI.DesktopDatePicker)`
  .Mui-disabled {
    background-color: rgb(242, 244, 248);
  }
`;

export const LabelText = styled.span`
  display: block;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  font-family: Inter-Medium;
  margin-bottom: 5px;
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 2px;
  width: 100%;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-adornedEnd {
    height: 44px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 4.5px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: ${color.primary} !important;
    }
  }
  .MuiOutlinedInput-input {
    padding-top: 10.5px;
    padding-bottom: 10.5px;
  }
`;
